import React from 'react';

import SectionTitle from '../../components/SectionTitle'
import SinglePost from '../../components/Blog/SinglePost';

import posts from '../../data/Posts.json';

const Blog = ({blogList}) => {

    return (
        <>
            <div className="react-blog__area blog__area py-5 graybg-home">
                <div className="container blog__width">
                    <SectionTitle Title="Blogs &" subtitle=" Events" />
                    <div className="row g-4 mb-md-5">
                        {blogList?.map((data, index) => {
                            return (
                                <div key={index} className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 wow animate__fadeInUp" data-wow-duration="0.3s">
                                    {
                                        <SinglePost
                                            blogID={data?._id}
                                            blogImage= {`${data?.thumbnailImgUrl}`}
                                            blogTitle= {data?.title}
                                            slug={data?.slug}
                                            desc={data?.shortDescription}
                                            blogPublishedDate= {data?.date}
                                        />
                                    }

                                </div>
                            )
                        }).slice(0, 4)}
                    </div>
                </div>
            </div>
        </>
    );

}

export default Blog;